import { useCallback, useMemo } from 'react';

import { ClaimRepayment, ClaimSelectPlace } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

const useModifyClaimRepayments = () => {
  const { editableLockbox, setEditableLockbox } = useLockboxDetailsStore();

  const claimRepayments = useMemo(() => editableLockbox?.claimRepayments, [editableLockbox]);

  const toggleClaim = useCallback((claimId?: string, selectPlace?: ClaimSelectPlace, claimData?: ClaimRepayment) => {
    const isClaimRepaymentAdded = !!claimRepayments?.find((claimRepayment) => claimRepayment?.claimId === claimId);
    if (isClaimRepaymentAdded) {
      const updatedClaimRepayments: ClaimRepayment[] = claimRepayments?.filter((claimRepayment) => claimRepayment?.claimId !== claimId) || [];
      setEditableLockbox({ claimRepayments: updatedClaimRepayments });
      return;
    }
    const updatedClaimRepayments: ClaimRepayment[] = [...claimRepayments || [], { claimId, selectPlace, ...claimData }];
    setEditableLockbox({ claimRepayments: updatedClaimRepayments });
  }, [claimRepayments, setEditableLockbox]);

  const setClaimAllocateAmount = useCallback((claimId?: string, repaymentAmount?: string) => {
    if (!claimId) {
      return null;
    }
    const updatedClaimRepayments: ClaimRepayment[] = claimRepayments?.map((claimRepayment) => {
      if (claimRepayment?.claimId === claimId) {
        return { ...claimRepayment, repaymentAmount };
      }
      return claimRepayment;
    }) || [];
    setEditableLockbox({ claimRepayments: updatedClaimRepayments });
  }, [claimRepayments, setEditableLockbox]);

  return {
    toggleClaim,
    setClaimAllocateAmount,
  };
};

export default useModifyClaimRepayments;
